/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { SaleStatus } from '../types/utils';

export class SaleStatusChangeLogEntry {
	createdAt?: Date

	data?: string

	status: SaleStatus = SaleStatus.INACTIVE
}